import React from 'react';

const ArtistContentMainCredits = (props:any) => {
const credits = props.artistCredits;

return (
    <div className={'font-bold mb-2 text-gray-500'} data-grid-artist-credit="true" dangerouslySetInnerHTML={{__html:credits}}>
    </div>
)
}

export default ArtistContentMainCredits;